<template>
  <div class="swiper-box">
    <div class="swiper-bg"></div>
    <div class="swiper-close" @click="closeSwiper"></div>
    <swiper ref="mySwiper" class="swiper-ref" :options="swiperOptions">
      <swiper-slide v-for="(imgItem, imgIndex) in imgList" :key="imgIndex">
        <!-- <img-view :src="imgItem" class="swiper-img"></img-view> -->
        <div class="swiper-zoom-container">
          <img :data-src="imgItem" class="swiper-img swiper-lazy" />
        </div>
        <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
      </swiper-slide>
      <div
        class="swiper-button-prev"
        style="color: #e5b627"
        slot="button-prev"
      ></div>
      <div
        class="swiper-button-next"
        style="color: #e5b627"
        slot="button-next"
      ></div>
    </swiper>
    <div class="text-box">
      <div class="pic-num-box">
        <span class="pic-nowNum">{{ nowIndex }}</span> /
        <span class="pic-total">{{ imgTotal }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
// import imgView from "./imgView";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    baseFile: "",
    baseUrl: "",
    imgNowIndex: "",
    imgTotal: "",
  },
  data() {
    return {
      nowIndex:"",
      swiperOptions: {
        zoom: {
          maxRatio: 3,
          minRatio: 1,
        },
        lazy: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: (swiper)=> {
           
             this.nowIndex = this.swiper.activeIndex + 1
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    imgList() {
      var imgArr = [];
      for (let index = 0; index < this.imgTotal; index++) {
        imgArr.push(
          `./images/${this.baseFile}/${this.baseUrl}/${index + 1}.jpg`
        );
      }
      this.nowIndex = this.imgNowIndex
      return imgArr;
    },
  },
  methods: {
    closeSwiper() {
      this.$emit("closeSwiper");
    },
  },
  mounted() {
    var that = this;
    this.swiper.slideTo(this.imgNowIndex - 1, 0, false);
    document
      .querySelector(".swiper-ref")
      .addEventListener("mousewheel", function (e) {
  

        var delta = -e.wheelDelta || e.detail;
        if (delta > 0) {
          that.swiper.zoom.out();
        }
        //上滚
        if (delta < 0) {
 
          that.swiper.zoom.in();
        }
      });
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.swiper-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  .swiper-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba($color: #000000, $alpha: 0.6);
  }
  .swiper-close {
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
    width: 3.4rem;
    height: 3.4rem;
    background: url("../assets/img/close-btn.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 100;
  }
  .swiper-ref {
    width: 100%;
    height: 100%;
    .swiper-img {
      width: auto;
      height: auto;
      max-width: 80%;
      max-height: 100%;
      // transform: translate(-50%, -50%);
      // position: absolute;
      // left: 50%;
      // top: 50%;
    }
  }
  .text-box {
    width: 80%;
    height: 30px;
    position: absolute;
    bottom: 20px;
    left: 2%;
    z-index: 100;
    .pic-num-box {
      width: 200px;
      height: 100%;
      color: #aa0000;
      font-size: 20px;
      padding-top: 0.1rem;
      .pic-nowNum {
        font-size: 24px;
        color: #e5b627;
        margin-top: -0.2rem;
      }
    }
  }
}
</style>